import { createRouter, createWebHistory } from 'vue-router';

import Resellers from './views/resellers';
import Contactdemo from './views/contactdemo';
import ContactMini from './views/contactMini';
import './style.css';

// Vue 3 migration: vue-router v4 uses createRouter/createWebHistory.
export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'Resellers',
      path: '/resellers',
      component: Resellers,
    },
    {
      name: 'Contactdemo',
      path: '/contactdemo',
      component: Contactdemo,
    },
    {
      name: 'ContactMini',
      path: '/contactMini',
      component: ContactMini,
    },
    {
      name: 'Home',
      path: '/',
      component: Resellers,
    },
  ],
})
